import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import ExcessiveScheduleTasksReportCriteria from './ExcessiveScheduleTasksReportCriteria';
import { Neo } from '@singularsystems/neo-react';

@NeoReport("ExcessiveScheduleTasks", { category: MaintenanceReportCategories.SystemInformationReports })
export default class ExcessiveScheduleTasksReport extends Report<ExcessiveScheduleTasksReportCriteria> {

    constructor() {
        super(ExcessiveScheduleTasksReportCriteria);
    }

    public renderCriteria() {
        return (
            <>
                <Neo.GridLayout lg={3} md={3}>
                    <Neo.FormGroup bind={this.criteria.meta.limit} />
                </Neo.GridLayout>
            </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}